const mainRootElement = document.querySelector(":root");
const sectionHeader = document.querySelector("#shopify-section-header");
const searchToggler = document.querySelector(".search-toggler");
const headerSearch = document.querySelector(".header-search__desktop");
const mobileNavDrawer = document.querySelector(".mobile-navigation-drawer");
const mobileSubMenuToggler = document.querySelectorAll(
  ".navigation__children-toggle"
);
const mobileSubMenuBack = document.querySelector(".mobile-nav-back");
const mobileSortByTriggerButton = document.querySelector(
  ".mobile-sortby__trigger-button"
);
const sortByItemsMobile = document.querySelectorAll(
  ".mobile-sortby__options-list-item-input"
);
const requestFilterPopupTrigger = document.querySelector(
  ".request-filter__block-link"
);
const requestFilterPopup = document.querySelector(
  ".request-filter__block-popup"
);

searchToggler &&
  searchToggler.addEventListener("click", () => {
    headerSearch &&
      headerSearch.classList.toggle("header-search__desktop-visible");
    searchToggler &&
      searchToggler.classList.toggle("search-toggler__open-search");
  });

document.querySelector(".clear-field__button").addEventListener("click", () => {
  headerSearch &&
    headerSearch.classList.remove("header-search__desktop-visible");
});

const setHeaderHeight = () => {
  mainRootElement.style.setProperty(
    "--section-header-height",
    sectionHeader.offsetHeight + "px"
  );
};

window.addEventListener("DOMContentLoaded", setHeaderHeight);
window.addEventListener("resize", setHeaderHeight);

document.addEventListener("DOMContentLoaded", () => {
  mobileSubMenuToggler &&
    mobileSubMenuToggler.forEach((singleMobileSubMenuToggler) => {
      singleMobileSubMenuToggler.addEventListener("click", () => {
        setTimeout(() => {
          mobileNavDrawer.style.overflow = "hidden";
        }, 500);
      });
    });

  mobileSubMenuBack.addEventListener("click", () => {
    mobileNavDrawer.style.overflow = "auto";
  });
});

mobileSortByTriggerButton &&
  mobileSortByTriggerButton.addEventListener("click", () => {
    mobileSortByTriggerButton.classList.toggle(
      "mobile-sortby__options--visible"
    );
  });

window.addEventListener("DOMContentLoaded", () => {
  sortByItemsMobile.forEach((sortByItemMobile) => {
    document
      .querySelector(".mobile-sortby_submit")
      .addEventListener("click", () => {
        if (location.href.indexOf("?") >= 0) {
          if (sortByItemMobile.checked) {
            var queryTerms = location.href.split("?")[1].split("&");
            var newHref = sortByItemMobile.dataset.link;
            queryTerms.forEach((term) => {
              if (term.indexOf("sort_by=") === -1) {
                newHref += "&" + term;
              }
            });
            sortByItemMobile.dataset.link = newHref;
            location.href = newHref;
          }
        } else {
          location.href = sortByItemMobile.dataset.link;
        }
      });
  });
});

requestFilterPopupTrigger &&
  requestFilterPopupTrigger.addEventListener("click", () => {
    requestFilterPopup.classList.add("request-filter__block-popup--visible");
  });

requestFilterPopup &&
  requestFilterPopup.addEventListener("click", (e) => {
    if (
      e.target.classList.contains("request-filter__popup-close") ||
      e.target.classList.contains("request-filter__block-popup")
    ) {
      requestFilterPopup.classList.remove(
        "request-filter__block-popup--visible"
      );
    }
  });
